var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"required-text"},[_c('span',[_vm._v("*")]),_vm._v(" "+_vm._s(_vm.$t("generic.required_field")))])}
var staticRenderFns = []

export { render, staticRenderFns }